import { render, staticRenderFns } from "./caldarTctDialog.vue?vue&type=template&id=2b47c800&scoped=true&"
import script from "./caldarTctDialog.vue?vue&type=script&lang=js&"
export * from "./caldarTctDialog.vue?vue&type=script&lang=js&"
import style0 from "./caldarTctDialog.vue?vue&type=style&index=0&id=2b47c800&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b47c800",
  null
  
)

export default component.exports